var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateDistrubutor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07B52"
    },
    d: "M499.725,163.607L260.792,1.473c-2.893-1.963-6.69-1.964-9.583,0L12.275,163.607 c-2.34,1.587-3.742,4.231-3.742,7.06v332.8c0,4.713,3.821,8.533,8.533,8.533h477.867c4.713,0,8.533-3.821,8.533-8.533v-332.8 C503.467,167.838,502.066,165.194,499.725,163.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5563C"
    },
    d: "M34.134,503.467v-332.8c0-2.829,1.402-5.473,3.742-7.061L268.8,6.907l-8.009-5.435 c-2.893-1.963-6.69-1.964-9.583,0L12.275,163.606c-2.34,1.588-3.742,4.233-3.742,7.061v332.8c0,4.713,3.821,8.533,8.533,8.533h25.6 C37.954,512,34.134,508.181,34.134,503.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74757B"
    },
    d: "M409.6,204.8H102.4c-4.713,0-8.533,3.821-8.533,8.533v290.133c0,4.713,3.821,8.533,8.533,8.533h307.2 c4.713,0,8.533-3.821,8.533-8.533V213.334C418.134,208.621,414.313,204.8,409.6,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606268"
    },
    d: "M102.4,204.8c-4.713,0-8.533,3.821-8.533,8.533v290.133c0,4.713,3.821,8.533,8.533,8.533h17.067 V204.8H102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C4C6"
    },
    d: "M426.667,170.667H85.334c-4.713,0-8.533,3.821-8.533,8.533v34.133c0,4.713,3.821,8.533,8.533,8.533 h341.333c4.713,0,8.533-3.821,8.533-8.533V179.2C435.2,174.488,431.379,170.667,426.667,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB0B4"
    },
    d: "M426.667,204.8H85.334c-4.713,0-8.533-3.821-8.533-8.533v17.067c0,4.713,3.821,8.533,8.533,8.533 h341.333c4.713,0,8.533-3.821,8.533-8.533v-17.067C435.2,200.981,431.379,204.8,426.667,204.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5563C"
    },
    d: "M290.134,76.8h-68.267c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h68.267 c4.713,0,8.533,3.821,8.533,8.533C298.667,72.98,294.846,76.8,290.134,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5563C"
    },
    d: "M290.134,110.934h-68.267c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h68.267 c4.713,0,8.533,3.821,8.533,8.533S294.846,110.934,290.134,110.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5563C"
    },
    d: "M290.134,145.067h-68.267c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h68.267 c4.713,0,8.533,3.821,8.533,8.533C298.667,141.246,294.846,145.067,290.134,145.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDDD85"
    },
    d: "M204.8,273.067H102.4c-4.713,0-8.533,3.821-8.533,8.533V384c0,4.713,3.821,8.533,8.533,8.533 l51.2,8.533l51.2-8.533c4.713,0,8.533-3.821,8.533-8.533V281.6C213.334,276.888,209.514,273.067,204.8,273.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDDD85"
    },
    d: "M204.8,392.534H102.4c-4.713,0-8.533,3.821-8.533,8.533v102.4c0,4.713,3.821,8.533,8.533,8.533 h102.4c4.713,0,8.533-3.821,8.533-8.533v-102.4C213.334,396.355,209.514,392.534,204.8,392.534z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD042"
    },
    d: "M110.934,503.467v-102.4c0-4.713,3.821-8.533,8.533-8.533H102.4c-4.713,0-8.533,3.821-8.533,8.533 v102.4c0,4.713,3.821,8.533,8.533,8.533h17.067C114.754,512,110.934,508.181,110.934,503.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C127"
    },
    d: "M170.667,392.534h-34.133V435.2c0,4.713,3.821,8.533,8.533,8.533h17.067 c4.713,0,8.533-3.821,8.533-8.533V392.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74757B"
    },
    d: "M170.667,494.934h-34.133c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h34.133 c4.713,0,8.533,3.821,8.533,8.533S175.38,494.934,170.667,494.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD042"
    },
    d: "M110.934,384V281.6c0-4.713,3.821-8.533,8.533-8.533H102.4c-4.713,0-8.533,3.821-8.533,8.533V384 c0,4.713,3.821,8.533,8.533,8.533h17.067C114.754,392.534,110.934,388.714,110.934,384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C127"
    },
    d: "M170.667,273.067h-34.133v42.667c0,4.713,3.821,8.533,8.533,8.533h17.067 c4.713,0,8.533-3.821,8.533-8.533V273.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74757B"
    },
    d: "M170.667,375.467h-34.133c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h34.133 c4.713,0,8.533,3.821,8.533,8.533S175.38,375.467,170.667,375.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDDD85"
    },
    d: "M324.267,392.534h-102.4c-4.713,0-8.533,3.821-8.533,8.533v102.4c0,4.713,3.821,8.533,8.533,8.533 h102.4c4.713,0,8.533-3.821,8.533-8.533v-102.4C332.8,396.355,328.98,392.534,324.267,392.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD042"
    },
    d: "M230.4,503.467v-102.4c0-4.713,3.821-8.533,8.533-8.533h-17.067c-4.713,0-8.533,3.821-8.533,8.533 v102.4c0,4.713,3.821,8.533,8.533,8.533h17.067C234.221,512,230.4,508.181,230.4,503.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C127"
    },
    d: "M290.134,392.534H256V435.2c0,4.713,3.821,8.533,8.533,8.533H281.6c4.713,0,8.533-3.821,8.533-8.533 V392.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74757B"
    },
    d: "M290.134,494.934H256c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h34.133 c4.713,0,8.533,3.821,8.533,8.533S294.846,494.934,290.134,494.934z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDistrubutor);
export default __webpack_public_path__ + "static/media/create-distrubutor.9a5ad7bc5638f71eff760aac8285d432.svg";
export { ForwardRef as ReactComponent };